import React, { useState } from 'react';
import { historyPropType } from '~/config/routerPropTypes';
import { createCorporation, showCorporation } from '~/config/routes';
import Request from '~/providers/Request';
import CorporationRecord from '~/records/CorporationRecord';
import Form from './Form';
import dig from 'object-dig';
import { toast } from 'react-toastify';

function NewRecord({ history }) {
  const [record, setRecord] = useState(new CorporationRecord());
  const [loading, setLoading] = useState(false);

  async function onSubmit(saveAndContinue) {
    // Validar se o tipo de empresa foi selecionado
    const config = record.get('config_corporation') || {};
    if (config.corporation_type === null || config.corporation_type === undefined) {
      toast.error('Tipo de empresa é obrigatório');
      return;
    }

    // Validações específicas
    const validationErrors = record.validateCorporationFields();
    if (validationErrors.length > 0) {
      validationErrors.forEach(error => toast.error(error));
      return;
    }

    const corporationType = config.corporation_type;

    setLoading(true);

    try {
      // Removido: criação automática de wallet_id
      if ((corporationType === 'franchise' || corporationType === 'insurance') && !config.wallet_id) {
        config.wallet_id = '';
      }

      const data = record.toParams({
        owner_id: dig(record.get('owner'), 'id'),
      });

      // if country id is equal 2 (USA), remove city_id and owner_id on data json
      data.data.attributes.country_id = data.data.attributes.country.id;

      // se corporation_type for 'null' significa que é uma empresa padrão, então remove o campo
      if (!corporationType || corporationType === 'null' || corporationType === 'Cliente') {
        delete config.corporation_type;
        delete data.data.attributes.config_corporation.corporation_type;
      }

      const resp = await Request.post('/admin/corporation', data, {}, { controller: 'corporation' });

      setLoading(false);
      if (saveAndContinue) {
        history.push(createCorporation.spec);
      } else {
        history.push(showCorporation.reverse(resp.data));
      }
    } catch (e) {
      console.error(e);
      setLoading(false);
    }
  }

  const handleChange = (attrs) => {
    setRecord((prevRecord) => {
      // Se o país não mudou, apenas atualiza os atributos sem resetar
      if (
        !attrs ||
        !prevRecord ||
        !attrs.country ||
        !prevRecord.country ||
        attrs.country.id === parseInt(prevRecord.country.id)
      ) {
        return prevRecord.updateAttributes(attrs);
      }

      return prevRecord.updateAttributes({
        ...prevRecord, // Mantém os valores atuais dos outros campos
        country: attrs.country,
        name: '',
        email: '',
        phone: '',
        cnpj: '',
        street: '',
        district: '',
        number: '',
        postal_code: '',
        contact_name: '',
        contact_phone: '',
        contract_expires_at: '',
        disabled_at: null,
        frozen_at: null,
        city: null,
        is_driving: false,
        is_doctor: false,
        is_doctor_all: false,
        is_plan: false,
        is_emergency: false,
        partner: null,
        users_limit: null,
        corporation: null,
        owners: [],
        specialties: [],
        packs: [],
        corporation_doctors: [],
        config_corporation: {
          required_cns: true,
          required_location: true,
          required_documents: false,
          has_benefits_club: false,
          required_email: true,
          user_welcome_email: false,
          corporation_type: null,
          wallet_id: '',
          landing_url: '',
          accession_percentage: 0,
          signature_percentage: 0,
          income_value: 0,
        },
      });
    });
  };

  return (
    <Form
      onSubmit={onSubmit}
      record={record}
      handleChange={handleChange}
      loading={loading}
      setRecord={setRecord}
    />
  );
}

NewRecord.propTypes = {
  history: historyPropType,
};

export default NewRecord;
